import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { DatePipe } from '@angular/common';

import { TranService, TranType, TransactionId } from '../../services/tran.service';
import { WarehouseService, WarehouseId } from '../../services/warehouse.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { SelectOption } from '../../globals';
import { Utils } from '../../util';
import { PurchaseOrderId, PurchaseOrderService } from '../../services/purchase-order.service';
import { FirestoreService, BatchElement } from '../../services/firestore/firestore.service';

@Component({
  selector: 'app-read-in-tran',
  templateUrl: './read-in-tran.component.html',
  styleUrls: ['./read-in-tran.component.css']
})
export class ReadInTranComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  loaded: boolean = false;
  permission: any = {};

  transaction$: Observable<any[]>;
  transactions: any;

  wareId: string = '';

  dateFilter: '15days' | 'always' = '15days';
  get days15FromToday(){
    let date = new Date();
    date.setDate(date.getDate() - 15);
    return Utils.stringDate(date);
  }
  receivedAll: boolean = false;

  modalActionsWarehouse = new EventEmitter<string|MaterializeAction>();
  modalParamsWarehouse = [{dismissible: true}];

  warehouses = {};
  wareSelect: SelectOption[] = [];

  // -------- Code for filter, search and pagination --------
  data:Array<any>;
  rows:Array<any> = [];
  columns:Array<any> = [
    {title: 'Fecha', name: "date", sort: 'desc'},
    {title: 'Folio', name: "folio"},
    {title: 'Almacén', name: 'warehouse'},
    {title: 'Tipo de entrada', name: 'inType'},
    {title: 'OdP', name: 'odpNames'},
    {title: 'OdC', name: 'odcFolios'},
    {title: 'Factura', name: 'billFolio'},
    {title: 'Observaciones', name: 'observations'},
    {title: 'Cancelado', className: 'center', name: 'canceled_icon'},
    { title: 'Acciones',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
      { name: 'clear', title: '', styleIcon: 'clear', action: 'onCancel', styleClass: 'btn-floating btn waves-effect red lighten-1' },
      { name: 'edit', title: '', styleIcon: 'visibility', action: 'viewTransaction', styleClass: 'btn-floating btn waves-effect blue darken-1' }
  ] } }
  ];
  page: number = 1;
  itemsPerPage: number = 5;
  maxSize: number = 5;
  numPages: number = 1;
  length: number = 0;

  config:any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {filterString: ''},
    api: {
      onCancel: this.openModalCancel.bind(this),
      viewTransaction: this.viewTransaction.bind(this)
    }
  };

  tranSub: Subscription;
  subs: Subscription[] = [];

  constructor(
    private service: TranService,
    private warehouseService: WarehouseService,
    private settings: CatalogsSettingsService,
    private afh: FirestoreService,
    private odcService: PurchaseOrderService,
    private fb: FormBuilder,
		private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, 'inTran');
        if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
        else this.allowed = true;
    });

    let subSet = this.settings.getPayrollSettings('1').subscribe(setting => {
      this.itemsPerPage = setting.tableQuantity;
      subSet.unsubscribe();
    });
    this.tranSub = this.service.getTransactions({fromDate: this.days15FromToday}).subscribe(this.onSubscribe);
    this.subs.push(
      this.warehouseService.getWarehouses().subscribe(warehouses => {
        let select: SelectOption[] = [];
        warehouses.map(ware => {
          select.push({name: ware.name, value: ware.id});
        });
        this.wareSelect = select;
        this.wareId = this.wareSelect[0].value;
      })
    );
  }

  ngOnInit() {
  }
  ngOnDestroy(){
    this.tranSub.unsubscribe();
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    });
  }

  /////////// Filter
  onSubscribe = tempTransactions => {
    this.transactions = tempTransactions.filter(({type}) => type == TranType.In).map((tran: any) => {
      tran.inType = tran.inOutTypeObj.description;
      tran.warehouse = tran.warehouseObj.name;
      tran.canceled_icon = tran.canceled ? `<i class="small material-icons">done</i>` : `<i class="small material-icons">clear</i>`;
      if(!tran.billFolio) tran.billFolio = 'N.A.';
      tran.odpNames = '';
      tran.odcFolios = '';
      this.getTranData(tran);
      return tran;
    });
    this.onDateFilterChange();
    this.loaded = true;
  }
  onDateFilterChange(){
    console.log(`Changed to ${this.dateFilter}`);
    if(this.dateFilter == 'always' && !this.receivedAll){
      this.receivedAll = true;
      this.loaded = false;
      this.tranSub.unsubscribe();
      this.tranSub = this.service.getTransactions().subscribe(this.onSubscribe);
    }else{
      this.data = this.transactions.filter(tran => this.dateFilter == 'always' || tran.date >= this.days15FromToday);
      this.length = this.data.length;
      console.log(`New Length: ${this.length}`);
      this.onChangeTable(this.config);
    }
  }
  /////////// Filter

  odcFolios: {[id: string]: PurchaseOrderId['folio']} = {};
  async getTranData(inTran: TransactionId){
    let tranOdcFolios: number[] = [];
    let tranOdpNames: string[] = [];
    for(let pr of inTran.prInTransaction){
      if(pr.odpName) tranOdpNames.push(pr.odpName);
      if(pr.odcId){
        if(!this.odcFolios[pr.odcId]){
          let odc = pr.odcId ? await this.afh.docWithId<PurchaseOrderId>(`${this.odcService.collection}/${pr.odcId}`) : null;
          this.odcFolios[pr.odcId] = odc && odc.folio || undefined;
        }
        if(this.odcFolios[pr.odcId]) tranOdcFolios.push(this.odcFolios[pr.odcId]);
      }
    }
    inTran['odcFolios'] = [...new Set(tranOdcFolios)].join(', ');
    inTran['odpNames'] = [...new Set(tranOdpNames)].join(', ');
  }

  onCreate(){
    if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
    this.openModalWarehouse();
  }

  addWarehouse(){
    this.closeModalWarehouse();
    this.router.navigate([`/new_in_tran/${this.wareId}`]);
  }
  

  openModalWarehouse() {
    this.modalActionsWarehouse.emit({ action: 'modal', params: ['open'] });
  }

  closeModalWarehouse() {
    this.modalActionsWarehouse.emit({ action: 'modal', params: ['close'] });
  }
  viewTransaction(data: any): any {
    this.router.navigate(['/vw_tran/' + data.row.id]);
  }

  reasonMsg: string = '';
  cancelingTran: TransactionId = null;
  async continueCancel(){
    if(!this.reasonMsg) return toast('Ingrese una justificación.', 2000);
    try{
      let odcsForUpdate: Partial<PurchaseOrderId>[] = [];
      let totalInWareQuantity = 0;
      if(!this.cancelingTran.canceled) for(let tranPr of this.cancelingTran.prInTransaction){
        if(!tranPr.odcId) continue;
        let odc = await this.afh.docWithId<PurchaseOrderId>(`${this.odcService.collection}/${tranPr.odcId}`);
        if(!odc) continue;
        let {prForOrders} = odc;
        let {odcId, quantity: inWareQuantity, ref} = tranPr;
        totalInWareQuantity += inWareQuantity;
        let pr = prForOrders.find(pr => pr.id && pr.id == ref.id);
        if(!pr || !pr.inWareQuantity) continue;
        pr.inWareQuantity -= inWareQuantity;
        odcsForUpdate.push({id: odcId, prForOrders});
        //DOING: putting update to remove products form warehouse
        let products = (this.cancelingTran.warehouseObj || <any>{}).products || [];
        let warePr = products.find(pr => pr.ref.id == ref.id);
        if(warePr) warePr.quantity -= inWareQuantity;
      }
      let batch: BatchElement<'update'>[] = [
        {type: 'update', docPath: `${this.service.collection}/${this.cancelingTran.id}`, data: <Partial<TransactionId>>{
          canceled: true,
          cancelReasons: [
            ...(this.cancelingTran.cancelReasons || []),
            {datetime: `${Utils.today}, ${Utils.time}`, msg: this.reasonMsg},
          ],
        }},
      ];
      if(!this.cancelingTran.canceled && this.cancelingTran.warehouseObj) batch.push(
        {type: 'update', docPath: `${this.warehouseService.collection}/${this.cancelingTran.warehouseObj.id}`, data: <Partial<WarehouseId>>{
          products: this.cancelingTran.warehouseObj.products
        }}
      )
      odcsForUpdate.map(({id, prForOrders}) => {
        batch.push({type: 'update', docPath: `${this.odcService.collection}/${id}`, data: {prForOrders}});
      });
      let success = await this.afh.batch(batch);
      if(!success) throw null;
      this.reasonMsg = '';
      this.closeModalCancel();
      toast('Éxito', 2000);
    }catch(error){
      toast('Error inesperado.', 2000);
    }
  }

  ////////////////////////////////////////////////////////////////////Cancel
  modalActionsCancel = new EventEmitter<string|MaterializeAction>();
  modalParamsCancel = [{dismissible: true}];
  openModalCancel({row: odc}: {row: TransactionId}) {
    this.cancelingTran = odc;
    this.modalActionsCancel.emit({ action: 'modal', params: ['open'] });
  }
  closeModalCancel() {
    this.modalActionsCancel.emit({ action: 'modal', params: ['close'] });
  }
  ////////////////////////////////////////////////////////////////////Cancel

  /*********** Filter, sort, and pagination */

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }
    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }
  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columns.forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columns.forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }
  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }
  changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

}